import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class MilestoneSlide extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'MilestoneSlide'
  // Define default properties here
  static instanceDefaults() {
    return {
    }
  }
}
const servicePath = 'milestone/slide'
const servicePlugin = makeServicePlugin({
  Model: MilestoneSlide,
  service: feathersClient.service(servicePath),
  servicePath,
  namespace: 'milestone-slide',
  actions: {
    async reorderSlides({ dispatch }, { slides }) {
      /**
       * Reorder slides within a slideshow using individual PATCH calls.
       */
      const patches = slides.map((slide, index) =>
        dispatch('patch', [slide.id, { order: index + 1 }])
      )

      await Promise.all(patches)
    }
  }
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin